import { useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

function buildBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const crumbs: BreadcrumbItem[] = [{ label: "Dashboard", href: "/" }];
  if (pathname === "/") return crumbs;

  const segments = pathname.split("/").filter(Boolean);

  if (segments[0] === "licitaciones") {
    crumbs.push({ label: "Licitaciones", href: "/licitaciones" });
    if (segments.length === 1) return crumbs;
    if (segments[1] === "nueva") { crumbs.push({ label: "Nueva" }); return crumbs; }

    const id = segments[1];
    const basePath = `/licitaciones/${id}`;
    crumbs.push({ label: "Detalle", href: basePath });
    if (segments.length === 2) return crumbs;

    switch (segments[2]) {
      case "documentos": crumbs.push({ label: "Documentos" }); break;
      case "chat": crumbs.push({ label: "Chat IA" }); break;
      case "agentes": crumbs.push({ label: "Agentes" }); break;
      case "editar": crumbs.push({ label: "Editar" }); break;
      case "propuestas":
        crumbs.push({ label: "Propuestas", href: `${basePath}/propuestas` });
        if (segments.length >= 4) crumbs.push({ label: "Editor" });
        break;
      default: crumbs.push({ label: segments[2] }); break;
    }
    return crumbs;
  }

  if (segments[0] === "chat") { crumbs.push({ label: "Chat IA" }); return crumbs; }
  if (segments[0] === "analytics") { crumbs.push({ label: "Analytics" }); return crumbs; }
  if (segments[0] === "notificaciones") { crumbs.push({ label: "Notificaciones" }); return crumbs; }

  if (segments[0] === "configuracion") {
    crumbs.push({ label: "Configuraci\u00f3n", href: "/configuracion/llm" });
    if (segments[1] === "llm") crumbs.push({ label: "Proveedores LLM" });
    else if (segments[1] === "perfil") crumbs.push({ label: "Perfil" });
    return crumbs;
  }

  segments.forEach((s) => crumbs.push({ label: s }));
  return crumbs;
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const breadcrumbs = buildBreadcrumbs(pathname);

  return (
    <nav aria-label="Breadcrumbs" className="flex items-center gap-1 text-sm">
      {breadcrumbs.map((crumb, i) => {
        const isLast = i === breadcrumbs.length - 1;
        return (
          <div key={`${crumb.label}-${i}`} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />}
            {isLast || !crumb.href ? (
              <span className={cn(isLast ? "text-gray-900 font-medium" : "text-gray-500")}>{crumb.label}</span>
            ) : (
              <Link to={crumb.href} className="text-gray-500 hover:text-gray-700 transition-colors">{crumb.label}</Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
